import type { errors as en } from '@/i18n/locales/en/errors';
import type { Translation } from '@/i18n/types';

export const errors: Translation<typeof en> = {
  loading: 'Caricamento di {{label}}…',
  forbidden: 'Non puoi vedere {{label}}.',
  notFound: 'Impossibile trovare {{label}}.',
  loadingFailed: 'Caricamento non riuscito di {{label}}: {{message}}',
  submitForbidden: 'Non puoi eseguire questa azione{{suffix}}',
  submitConflict: 'Questo è in conflitto con lo stato attuale{{suffix}}',
  submitGeneric: 'Qualcosa è andato storto: {{message}}',
};
